module.exports = __webpack_public_path__ + "img/subsidence.37575d9d.svg";